import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLongArrowAltRight} from "@fortawesome/free-solid-svg-icons";

import "./selected-date-header.scss";

import {cs} from "@Common/react/chain-services";

import {formatDate} from "../../../calendar-ui/format-date";

export const SelectedDateHeader = ({startDate, endDate}) => cs(
    ["startDate", (_, next) => {
        if (startDate.value == null) {
            return next(
                <div className="single">
                    Start Date
                </div>
            )
        }
        return next(
            <div className="start-date">
                <div className="date">
                    {formatDate(startDate.value)}
                </div>
                <div className="subtext">
                    Start Date
                </div>
            </div>
        )
    }],
    ["endDate", (_, next) => {
        if (endDate.value == null) {
            return next(
                <div className="single">
                    End Date
                </div>
            )
        }
        return next(
            <div className="end-date">
                <div className="date">
                    {formatDate(endDate.value)}
                </div>
                <div className="subtext">
                    End Date
                </div>
            </div>
        )

    }],
    ({startDate, endDate}) => (
        <div className="selected-date-header-9uc">
            {startDate}
            <FontAwesomeIcon className={"arrow"} icon={faLongArrowAltRight}/>
            {endDate}
        </div>
    )
);
